import { Button, Box, Stack, styled } from '@mui/material';

export const PlaybackStatsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gridColumn: 'span 4',
  padding: theme.spacing(2),
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  background: theme.palette.grey[800],
  borderRadius: theme.spacing(1),
}));

export const InfoContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(1),
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.between('md', 'desktop')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: theme.spacing(8),
  height: theme.spacing(5),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));
